import {getName, getNames} from "country-list";

const TAIWAN_NAME = getName("TW")!;

const COUNTRY_NAME_OVERRIDES: Record<string, string> = {
    [TAIWAN_NAME]: "Taiwan",
};

// Keep country names as IDs for compatibility with existing API values.
export const COUNTRIES = getNames().sort();

export const COUNTRY_OPTIONS = COUNTRIES.map((country) => ({
    id: country,
    label: COUNTRY_NAME_OVERRIDES[country] ?? country,
}));
